import React from "react";
import { Link, useNavigate } from "react-router-dom";
import SuceesfulGraphic from "../assets/images/SuceesfulGraphic.svg";

import Loader from "./Loader";
import usePlaidIntegration from '../components/Plaid'; 
import PlaidFallbackModal from "./PlaidFallbackModal"; 


const PaymentSuccess = () => {
  const navigate = useNavigate();

  const { openPlaid, isPlaidReady,isTokenLoading,isExchangingToken, showPlaidModal, modalVariant, modalMessage, modalSecondaryMessage, setShowPlaidModal, onTryAgain } = usePlaidIntegration("/q5");

  const isLoading = isTokenLoading || isExchangingToken;





  return (
    <div className="package-payment-wrap payment-page place-content-center text-center">
      {isLoading ? (<Loader />):(
        <>
        <img src={SuceesfulGraphic} alt="" />
      <h1 className="text-light mt-5 f-700">Payment Successful!</h1>
      <p className="mt-2 text-light f-400">
        Your subscription is now active thank you for trusting
        us with your goals.
      </p>
      <button
        type="submit"
        className="as-btn-secondary mt-4 mb-3 d-flex place-items-center mx-auto"
        onClick={openPlaid} // Use openPlaid from the hook
        disabled={!isPlaidReady}
      >
        Yes, Connect with Plaid &nbsp;&nbsp;
        <i className="iconoir-arrow-right"></i>
      </button>
      <div>
      <Link className="text-light text-underline" to={"/q5"}>
        <u>No, I’ll Enter Data Manually</u>
      </Link>
      </div>
        </>
      )}
      {showPlaidModal && (
        <PlaidFallbackModal 
          variant={modalVariant} 
          message={modalMessage} 
          secondaryMessage={modalSecondaryMessage} 
          onClose={() => { 
            setShowPlaidModal(false); 
            if (modalVariant === 'success') navigate('/q9'); 
          }} 
          onTryAgain={onTryAgain} 
        />
      )}
    </div>
  );
};

export default PaymentSuccess;
